import { type Component } from 'solid-js';
import Plans from '~/features/plans';
import Accounts from '~/features/accounts';
import Loans from '~/features/loans';
import Transactions from '~/features/transactions';

// Design a portfolio you do not own. The panes are the same ones the real book
// uses — holdings are still summed from buys, loans still allocate into
// accounts — because a plan you cannot build the same way you built the real
// thing is a plan you cannot trust the numbers of.
//
// Which plan they are showing is bound to the page, not to a mode: see the
// page-to-portfolio effect in root.tsx.
const PlanPage: Component = () => (
    <>
        <div class='w-48 shrink-0'>
            <Plans />
        </div>
        <div class='flex-1 min-w-0 flex flex-col gap-px'>
            <div class='flex-[2] min-h-0'>
                <Accounts />
            </div>
            <div class='flex-1 min-h-0'>
                <Loans />
            </div>
            <div class='flex-1 min-h-0'>
                <Transactions />
            </div>
        </div>
    </>
);

export default PlanPage;
